import React, { useState } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button, Icon, Popup, Table } from 'semantic-ui-react'
import { ClimateCheckSelectType } from '~/api/services/climaCheck';
import Dialog from '~/components/Dialog';
import { FormFields } from '~/components/FormFields';
import { years } from '../../constants';

interface Props {
  landTypes: ClimateCheckSelectType[]
}

const TableLandUse:React.FC<Props> = ({ landTypes }) => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  const [deleteLandChangeKey, setDeleteLandChangeKey] = useState(null)

  const { fields, append, remove } = useFieldArray({
    control: control,
    name: 'landTypeChanges',
    keyName: 'key'
  })

  function renderDeleteLandChangeModal() {
    return <Dialog
      type={'abort'}
      isDialogOpen={Boolean(deleteLandChangeKey)}
      textHeader={'Landnutzungsänderung löschen'}
      textContent={'Möchten Sie die Landnutzungsänderung wirklich löschen?'}
      textClose={t('Cancel')}
      textSubmit={t('Delete')}
      handleClose={() => setDeleteLandChangeKey(null)}
      handleSubmit={() => {
        const indexLandChange = fields.findIndex(landChange => landChange.key === deleteLandChangeKey)
        if(indexLandChange >= 0) {
          remove(indexLandChange)
        }
        setDeleteLandChangeKey(null)
      }}
    />
  }

  return <div>
    {renderDeleteLandChangeModal()}
    <Table celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>{'Umwandlung von'}</Table.HeaderCell>
          <Table.HeaderCell>{'Umwandlung nach'}</Table.HeaderCell>
          <Table.HeaderCell>{'Hektar'}</Table.HeaderCell>
          <Table.HeaderCell>{'Jahr'}</Table.HeaderCell>
          <Table.HeaderCell>{t('Actions')}</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {fields.map((landType, index) => {
          return <Table.Row key={landType.key}>
            <Table.Cell>
              <FormFields.Select
                control={control}
                name={`landTypeChanges[${index}].landTypeFrom`}
                withoutAsterisk
                options={landTypes.map(landOptions => ({ value: landOptions.id, text: landOptions.label }))}
                selectOnBlur={false}
                upward
                noErrorMessage
                rules={{
                  required: true
                }}
                placeholder={'Bitte auswählen'}
              />
            </Table.Cell>
            <Table.Cell>
              <FormFields.Select
                control={control}
                name={`landTypeChanges[${index}].landTypeTo`}
                withoutAsterisk
                upward
                selectOnBlur={false}
                options={landTypes.map(landOptions => ({ value: landOptions.id, text: landOptions.label }))}
                noErrorMessage
                rules={{
                  required: true
                }}
                placeholder={'Bitte auswählen'}
              />
  
            </Table.Cell>
            <Table.Cell>
              <FormFields.Input
                control={control}
                name={`landTypeChanges[${index}].area`}
                suffix={' ha'}
                withoutAsterisk
                allowDecimals
                decimalScale={1}
                rules={{
                  required: true
                }}
                typeInput='controled'
                noErrorMessage
                placeholder={'in ha'}
              />
            </Table.Cell>
            <Table.Cell>
              <FormFields.Select
                control={control}
                name={`landTypeChanges[${index}].year`}
                options={years.map(year => ({ value: year, text: year }))}
                search
                selectOnBlur={false}
                withoutAsterisk
                upward
                placeholder={'Bitte auswählen'}
                rules={{
                  required: true
                }}
                noErrorMessage
              />
            </Table.Cell>
            <Table.Cell>
              <Popup
                content={'Landnutzungsänderung löschen'}
                trigger={<Icon
                  onClick={() => setDeleteLandChangeKey(landType.key)}
                  name='trash'
                  color='red'
                  style={{ fontSize: '1.2em', cursor: 'pointer' }}
                />}
              />
            </Table.Cell>
          </Table.Row>
        })}
      </Table.Body>
    </Table>
    <Button
      floated='right'
      icon
      type='button'
      labelPosition='left'
      primary
      size='small'
      onClick={() => append({
        landTypeFrom: '',
        landTypeTo: '',
        area: '',
        year: ''
      })}
    >
      <Icon name='plus' /> {t('Add')}
    </Button>
  </div>
}
export default TableLandUse